import { supabase } from '../../lib/supabase';

export interface Contact {
    id: string;
    name: string;
    email?: string;
    phone?: string;
    whatsapp?: string;
    company?: string;
    profile_picture_url?: string | null;
    created_at?: string;
}

export const getContacts = async (): Promise<Contact[]> => {
    try {
        const { data, error } = await supabase
            .from('contacts')
            .select('id, name, email, phone, whatsapp, company, profile_picture_url')
            .order('name', { ascending: true });

        if (error) throw error;
        return data || [];
    } catch (err) {
        console.error('Error fetching contacts:', err);
        return [];
    }
};

